"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVENT_HAS_UNKEPT_PARTS_MESSAGE = exports.EVENT_NAME_TAKEN_MESSAGE = void 0;
exports.EVENT_NAME_TAKEN_MESSAGE = "An event form with this name already exists in this sample tracker.";
exports.EVENT_HAS_UNKEPT_PARTS_MESSAGE = "This event form has parts the editor cannot keep. It was not changed.";
